if (!customElements.get('drag-scroll')) {
  class DragScroll extends HTMLElement {
    connectedCallback() {
      this.threshold = 5;
      this.onDown = this.onDown.bind(this);
      this.onMove = this.onMove.bind(this);
      this.onUp = this.onUp.bind(this);
      this.onClick = this.onClick.bind(this);
      this.addEventListener('pointerdown', this.onDown);
      this.addEventListener('click', this.onClick, true);
      this.addEventListener('dragstart', (e) => e.preventDefault());
      this.updateState = this.updateState.bind(this);
      this.resizeObserver = new ResizeObserver(this.updateState);
      this.resizeObserver.observe(this);
      this.updateState();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.removeEventListener('pointerdown', this.onDown);
      this.removeEventListener('click', this.onClick, true);
    }

    isScrollable() {
      return this.scrollWidth - this.clientWidth > 1;
    }

    updateState() {
      this.classList.toggle('is-draggable', this.isScrollable());
    }

    onDown(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !this.isScrollable()) return;
      this.startX = event.clientX;
      this.startScroll = this.scrollLeft;
      this.moved = false;
      this.pointerId = event.pointerId;
      window.addEventListener('pointermove', this.onMove);
      window.addEventListener('pointerup', this.onUp);
      window.addEventListener('pointercancel', this.onUp);
    }

    onMove(event) {
      const dx = event.clientX - this.startX;
      if (!this.moved && Math.abs(dx) < this.threshold) return;
      if (!this.moved) {
        this.moved = true;
        this.classList.add('is-dragging');
      }
      event.preventDefault();
      this.scrollLeft = this.startScroll - dx;
    }

    onUp() {
      window.removeEventListener('pointermove', this.onMove);
      window.removeEventListener('pointerup', this.onUp);
      window.removeEventListener('pointercancel', this.onUp);
      this.classList.remove('is-dragging');
      if (this.moved) {
        this.suppressClick = true;
        setTimeout(() => (this.suppressClick = false), 0);
      }
    }

    onClick(event) {
      if (!this.suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      this.suppressClick = false;
    }
  }
  customElements.define('drag-scroll', DragScroll);
}
